import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import cn from 'classnames';
import { Trash } from '../../../icons';
import { IconButton } from '../../IconButton';
import { Typography } from '../../Typography';
import styles from '../EditableTableList.module.scss';
import { buttonBi, columnWidthClass, columnWidthStyle } from '../EditableTableList.utils';
import { SortableTableRow } from '../SortableTableRow';
export function EditableTableListDesktop(param) {
    let { rows, columns, onRemoveRow, renderRowFooter, bi, testIds, dnd } = param;
    const { dragEnabled, rowIds, rowIsStatic, withDndContext, withSortableItems } = dnd;
    const footerColSpan = columns.length + (onRemoveRow != null ? 1 : 0) + (dragEnabled ? 1 : 0);
    const renderRowCells = (row, rowIndex)=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                columns.map((column)=>/*#__PURE__*/ _jsx(TableCell, {
                        className: columnWidthClass(column),
                        style: columnWidthStyle(column),
                        "data-testid": testIds.Cell(rowIndex, column.key),
                        children: column.renderCell(row, rowIndex)
                    }, column.key)),
                onRemoveRow != null && /*#__PURE__*/ _jsx(TableCell, {
                    align: "right",
                    className: styles.removeCell,
                    children: !rowIsStatic(row, rowIndex) && /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({}, buttonBi(bi === null || bi === void 0 ? void 0 : bi.removeButton)), {
                        size: "small",
                        noPadding: true,
                        testId: testIds.RemoveButton(rowIndex),
                        onClick: ()=>onRemoveRow(rowIndex),
                        children: /*#__PURE__*/ _jsx(Trash, {
                            size: 24
                        })
                    }))
                })
            ]
        });
    return withDndContext(/*#__PURE__*/ _jsx(TableContainer, {
        className: styles.tableContainer,
        "data-testid": testIds.Root(),
        children: /*#__PURE__*/ _jsxs(Table, {
            children: [
                /*#__PURE__*/ _jsx(TableHead, {
                    children: /*#__PURE__*/ _jsxs(TableRow, {
                        children: [
                            dragEnabled && /*#__PURE__*/ _jsx(TableCell, {
                                padding: "checkbox"
                            }),
                            columns.map((column)=>/*#__PURE__*/ _jsx(TableCell, {
                                    className: cn(columnWidthClass(column), {
                                        [styles.inputAlignedHeader]: column.alignHeaderToInput
                                    }),
                                    style: columnWidthStyle(column),
                                    "data-testid": testIds.Header(column.key),
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        align: column.alignHeaderToInput ? undefined : 'center',
                                        children: column.header
                                    })
                                }, column.key)),
                            onRemoveRow != null && /*#__PURE__*/ _jsx(TableCell, {
                                className: styles.removeCell
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(TableBody, {
                    children: withSortableItems(rows.map((row, rowIndex)=>/*#__PURE__*/ _jsxs(React.Fragment, {
                            children: [
                                dragEnabled && !rowIsStatic(row, rowIndex) ? /*#__PURE__*/ _jsx(SortableTableRow, {
                                    id: rowIds[rowIndex],
                                    rowTestId: testIds.Row(rowIndex),
                                    handleTestId: testIds.DragHandle(rowIndex),
                                    children: renderRowCells(row, rowIndex)
                                }) : /*#__PURE__*/ _jsxs(TableRow, {
                                    "data-testid": testIds.Row(rowIndex),
                                    children: [
                                        dragEnabled && /*#__PURE__*/ _jsx(TableCell, {
                                            padding: "checkbox"
                                        }),
                                        renderRowCells(row, rowIndex)
                                    ]
                                }),
                                renderRowFooter != null && /*#__PURE__*/ _jsx(TableRow, {
                                    children: /*#__PURE__*/ _jsx(TableCell, {
                                        colSpan: footerColSpan,
                                        "data-testid": testIds.RowFooter(rowIndex),
                                        children: renderRowFooter(row, rowIndex)
                                    })
                                })
                            ]
                        }, rowIds[rowIndex])))
                })
            ]
        })
    }));
}
